import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const currencyDropdown = async () => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/currency`,
    );

    return response.data.map((item) => ({
      key: item.curId,
      text: item.curCurrency,
      value: item.curId,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const currencyContains = async (search) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/currency/namecontains`,
      search,
    );
    return response.data.map((item) => ({
      key: item.id,
      title: `[${item.code}] - ${item.text}`,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const currencyName = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/currency/name/${id}`,
    );
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};
